import { render, staticRenderFns } from "./LicenseView.vue?vue&type=template&id=91ee57b8&scoped=true&lang=html&"
import script from "./LicenseView.vue?vue&type=script&lang=js&"
export * from "./LicenseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ee57b8",
  null
  
)

export default component.exports